import React, { useState, useEffect, Suspense } from 'react';

import "./Home.css";
import { Link } from "react-router-dom";

const Slider2 = React.lazy(() => import("../components/Slider"));
const Carousel = React.lazy(() => import("../components/HomeCarousel"));

const Home = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [sliderLoaded, setSliderLoaded] = useState(false);
    const [initialImage, setInitialImage] = useState("");
    
    useEffect(() => {
        // Check if the user has already visited the site
        const hasVisited = localStorage.getItem('visited') === 'true';
        if (!hasVisited) {
            setShowPopup(true);
            localStorage.setItem('visited', 'true');
        }

        // Add a delay before setting sliderLoaded to true, if necessary
        setTimeout(() => {
            setSliderLoaded(true);
        }, 2000); // Adjust this delay as needed
    }, []);

    
    function determineImageFormat(webpURL, jpgURL) {
        const supportsWebP = (function () {
          const elem = document.createElement('canvas');
      
          if (!elem || !elem.getContext) {
            return false;
          }
      
          return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        })();
      
        return supportsWebP ? webpURL : jpgURL;
    }

    const slides = [
        { 
        id: 1,
        image: determineImageFormat("/data/photos/HomeSlider/Oregon2-1600x750.webp","/data/photos/HomeSlider/Oregon2-1600x750.jpg") ,
        alt: "obrazok"
        },
        { 
            id: 2,
            image: determineImageFormat("/data/photos/HomeSlider/Postel-Wood-1600x750.webp","/data/photos/HomeSlider/Postel-Wood-1600x750.jpg"),
            alt: "obrazok"
        },
        { 
            id: 3,
            image: determineImageFormat("/data/photos/HomeSlider/Miami-zlta-1600x750.webp","/data/photos/HomeSlider/Miami-zlta-1600x750.jpg"),
            alt: "obrazok"
        },
        { 
            id: 4,
            image: determineImageFormat("/data/photos/HomeSlider/Zostava-1600x750.webp","/data/photos/HomeSlider/Zostava-1600x750.jpg"),
            alt: "obrazok"
        },
      ];

    return ( 
        <section className="home-body">
            {showPopup && (
        <div className="popup-container">
          <div className="popup-content">
            <span className="close-btn" onClick={() => setShowPopup(false)}>
              &times;
            </span>
            <h2>Merry Christmas!</h2>
            <p>Wishing you a joyous and festive holiday season!</p>
          </div>
        </div>
      )}
            <div className="sliderContainerWrapper">
                <div className="sliderContainer">
                    {/* Static first image as background */}
                    <img
                        src={determineImageFormat("/data/photos/HomeSlider/Oregon2-1600x750.webp","/data/photos/HomeSlider/Oregon2-1600x750.jpg")}
                        alt="Slider1"
                        className="initial-image"
                    />
                    {sliderLoaded && (
                    <div className={`slider-overlay ${sliderLoaded ? 'slider-visible' : ''}`}>
                        <Slider2 slides={slides} />
                    </div>
                    )}
                </div>
            </div>
            <div className="about-couches" >
                <h2>SEDAČKY, KTORÉ VÁM SADNÚ</h2>
                <span></span>
                <p>KVALITNÉ SEDACIE SÚPRAVY NA MIERU OD SLOVENSKÉHO VÝROBCU <br />
                VEĽKÝ VÝBER POŤAHOVÝCH MATERIÁLOV <br />
                ZÁRUČNÝ A POZÁRUČNÝ SERVIS <br />
                DOPRAVA AŽ K VÁM DOMOV <br />
                3 VLASTNÉ PREDAJNE - MÝTNA NOVÁ VES, BRATISLAVA, TRENČÍN <br />
                OKREM SEDAČIEK U NÁS NÁJDETE POSTELE, MATRACE, KRESLÁ, STOLY A STOLIČKY</p>
            </div>
            <div className="carousel-container" >
                <Carousel />
            </div>
                
            {/*<div className="stats">
                <div className="stats-content">
                <Link to={`/Sedacky`} className="stats-card" onClick={ () => window.scrollTo(0,0)}>
                    <img src="/data/photos/logo/design.png" alt="" />
                        <h3>Sedačky na mieru</h3>
                        <p>Sedacie súpravy na mieru. Slovenský výrobca sedacích súprav s najväčou predajňou sedačiek s okamžitým odberom viac ako 300 druhov.</p>
                    </Link>
                    <Link to={`/Vzorkovniky`} className="stats-card" onClick={ () => window.scrollTo(0,0)}>
                            <img src="/data/photos/logo/fabric.png" alt="" />
                            <h3>Výber z množstva poťahov</h3>
                            <p>Pri návrhu svojej vysnívanej sedacej súpravy Vás nelimituje ani materiál, ani farba. Umožníme vám nájsť správnu kombináciu pre každý interiér.</p>
                    </Link>
                    <Link to={`/Sedacky`} className="stats-card" onClick={ () => window.scrollTo(0,0)}>
                    <img src="/data/photos/logo/production.png" alt="" />
                        <h3>Vlastná výroba</h3>
                        <p>Sedacie súpravy pre Vás vyrábame už 30 rokov. Zamestnávame kvalifikovaných pracovníkov, ktorí sa postarajú o kvalitu Vašej sedačky.</p>
                    </Link>
                    <div class="stats-card">
                        <img src="/data/photos/logo/delivery.png" alt="" />
                        <h3>Dostupná doprava</h3>
                        <p>Sedacie súpravy rozvážame po celom Slovensku i do blízkeho zahraničia za bezkonkurenčné ceny.</p>
                    </div>  
                </div>
                <Link to={`/Onas`} className="moreabout" onClick={window.scrollTo(0,0)}>Viac o nás</Link>
            </div>*/}
            
            <div className="visit-us">
                <h2>Naše predajne</h2>
                <span></span>
                <div className="visit-us-card-container">
                    <div className="visit-us-card">
                        <div className="visit-us-title-container">
                            <h3>Mýtná Nová Ves</h3>
                        </div>
                        <div className="visit-us-img-container">
                            <img src="/data/photos/Predajne/bilboardy__interstyle_6364.jpg" alt="" />
                        </div>
                        <div className="card-store">
                            <h4>Mýtná Nová Ves</h4>
                            <div className="card-address">
                                <ul>
                                    <li>Mýtna Nová Ves 148</li>
                                    <li>956 11 Ludanice</li>
                                    <li>Slovensko</li>
                                </ul>
                            </div>
                            <div className="card-hours">
                                <h5>Otváracie hodiny</h5>
                                <ul>
                                    <li>PO-SO: 9:00 - 19:00</li>
                                    <li>NE: 10:00 - 19:00</li>
                                </ul>
                            </div>
                            <a
                            href="https://maps.app.goo.gl/GmsJwZbL5tCkW9gz9"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="visit-us-title-container"
                            >
                            <h3>Navigovať</h3>
                            </a>
                        </div>
                    </div>
                    <div className="visit-us-card">
                        <div className="visit-us-title-container">
                            <h3>Bratislava</h3>
                        </div>
                        <div className="visit-us-img-container">
                            <img src="/data/photos/Predajne/Predajna_BA.png" alt="" />
                        </div>
                        <div className="card-store">
                            <h4>Bratislava</h4>
                            <div className="card-address">
                                <ul>
                                    <li>Ul. Svornosti 14</li>
                                    <li>82014 Bratislava</li>
                                    <li>Slovensko</li>
                                </ul>
                            </div>
                            <div className="card-hours">
                                <h5>Otváracie hodiny</h5>
                                <ul>
                                    <li>PO-SO: 9:00 - 19:00</li>
                                    <li>NE: 10:00 - 19:00</li>
                                </ul>
                            </div>
                            <div className="visit-us-title-container">
                            <a
                            href="https://maps.app.goo.gl/MV29JH9p584tgSVK7"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="visit-us-title-container"
                            >
                            <h3>Navigovať</h3>
                            </a>
                            </div>
                        </div>
                    </div>
                    <div className="visit-us-card">
                        <div className="visit-us-title-container">
                            <h3>Trenčín</h3>
                        </div>
                        <div className="visit-us-img-container">
                            <img src="/data/photos/Predajne/Bilboardy_TN_nahlad.png" alt="" />
                        </div>
                        <div className="card-store">
                            <h4>Trenčín</h4>
                            <div className="card-address">
                                <ul>
                                    <li>Belá - OC Laugaricio</li>
                                    <li>911 01 Trenčín</li>
                                    <li>Slovensko</li>
                                </ul>
                            </div>
                            <div className="card-hours">
                                <h5>Otváracie hodiny</h5>
                                <ul>
                                    <li>PO-SO: 9:00 - 19:00</li>
                                    <li>NE: 10:00 - 19:00</li>
                                </ul>
                            </div>
                            <div className="visit-us-title-container">
                            <a
                            href="https://maps.app.goo.gl/xvaVtUv11mVJb98M7"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="visit-us-title-container"
                            >
                            <h3>Navigovať</h3>
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
  }
  
  export default Home